/** Short clause snippets for live preview (not legal advice). */

export const PREVIEW_DISCLAIMER =
  'This preview is for discussion only and is not legal advice. Have an attorney review before filing.';

export function previewCustodySummary(scheduleSlug: string | undefined): string {
  if (!scheduleSlug) {
    return 'Choose a schedule type to see a short summary here.';
  }
  return `Residential schedule: ${scheduleSlug.replace(/-/g, ' ')}. Adjust pick-up/drop-off times and the pattern start date to match your order or agreement.`;
}

export function previewHolidaySummary(): string {
  return 'Holidays: alternate major holidays where practical, define school breaks and summer blocks, and specify travel notice (e.g. 30–60 days) if either parent travels with the children.';
}

export function previewCommunicationSummary(): string {
  return 'Communication: use a single written channel for child-related coordination, set reasonable response times for non-emergencies, and keep messages child-focused.';
}

export function previewExpenseSummary(): string {
  return 'Expenses: list categories you will share (medical, school, activities), receipt rules, and how reimbursements are requested and paid.';
}
